import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from '../../../../../../../core/projects.service';

@Component({
    selector: 'app-delivery-tracking-tab-wrapper',
    templateUrl: './delivery-tracking-tab-wrapper.component.html',
    styleUrls: ['./delivery-tracking-tab-wrapper.component.scss'],
    standalone: false
})
export class DeliveryTrackingTabWrapperComponent implements OnInit, OnDestroy {
  headersList: any[] = [
    { id: 0, label: 'Bid Items', qp: 'bid-items' },
    { id: 1, label: 'Materials', qp: 'materials' },
    { id: 2, label: 'Custom Fields', qp: 'custom-fields' },
  ];
  selectedTabId = 0;
  private readonly onDestroy: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private projectsService: ProjectsService,
  ) {}

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp?.dtTab) {
          const matched = this.headersList.find(o => o.qp === qp.dtTab);
          if (matched) {
            this.selectedTabId = matched.id;
          }
        }
      });
  }

  selectHeader(header: any): void {
    this.projectsService.closeRightPanel.next();
    this.selectedTabId = header.id;
    this.router.navigate([], {
      queryParams: { dtTab: header.qp },
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
